// src/models/fiscal/Condutor.js
export class Condutor {
  constructor(data = {}) {
    this.id = data.id ?? 0;
    this.filialId = data.filialId ?? 1;
    this.nome = data.nome ?? '';
    this.cpf = data.cpf ?? '';
    this.ativo = data.ativo ?? true;
  }
}
